import { render, staticRenderFns } from "./HeaderLevelEmployee.vue?vue&type=template&id=ff5acbea&scoped=true"
import script from "./HeaderLevelEmployee.vue?vue&type=script&lang=js"
export * from "./HeaderLevelEmployee.vue?vue&type=script&lang=js"
import style0 from "./HeaderLevelEmployee.vue?vue&type=style&index=0&id=ff5acbea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5acbea",
  null
  
)

export default component.exports